import React, {useEffect, useState} from 'react';
import _axios from "../../httpService"
import {prefixUrl} from "../../utils/utilsData";
import Swal from "sweetalert2";
import {useNavigate} from "react-router-dom";

const SelectProductStoreRoom = (props) => {
  let {selectedStore, type, forceShow} = props
  if (!type) {
    type = 'buy'
  }

  const [items, setItems] = useState([]);

  const [show, setShow] = useState(false)
  //backEnd Will Send A message To me Is there Is no StoreRoom
  const [message, setMessage] = useState({
    showMessage: false,
    message: "",
  });

  const navigateTo = useNavigate()

  useEffect(() => {
    _axios.get(prefixUrl() + "/product/?storesList").then(res => {

      const data = res.data;
      if (data.status) {
        // //debugger
        if (type === 'sell') {
          if (data.allStoresAccess || forceShow) {
            setItems(data.data)
            setShow(true)
          } else {
            selectedStore(data.storeId, data.storeName)
            setShow(false)
          }
        } else { //type === buy
          setItems(data.data)
          setShow(true)
        }
      } else {
        setMessage({
          showMessage: true,
          message: data.message
        })

        Swal.fire({
          title: data.message,
          text: "لطفا بعد از اعمال تغییرات مجددا تلاش کنید.",
          icon: 'error',
          showCancelButton: false,
          allowOutsideClick: false,
          showConfirmButton: true,
          confirmButtonText: 'برو به داشبورد'
        }).then((result) => {
          if (result.isConfirmed) {
            navigateTo("/dashboard")
          }
        })

      }
      // alert(data.message);


    })
  }, [])


  return (show && <>
      {message.showMessage ? <span>{message.message}</span> :
        <div className="solid-dyna-input" style={{width:'200px'}}>
          <label htmlFor="ANBAR__MABDAA">{props.title}</label>
          <select
            id={'ANBAR__MABDAA'}
            className=""
            onChange={(e) => selectedStore(e.target.value, e.target.options[e.target.selectedIndex].text
            )}
            defaultValue=""
          >
            <option value="" hidden={true}>لطفا یک انبار انتخاب کنید</option>
            {
              items.map((option, index) =>
                <option key={index} value={option.storeId}>{option.storeName}</option>
              )
            }
          </select>
        </div>
      }
    </>
  );
};

export default SelectProductStoreRoom;
